import { push } from "connected-react-router";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { TypesErrorRequest } from "../../utils/types";
import { AppActions } from "../ducks/app";
import { RegisterActions, Types } from "../ducks/register";
import { AmplitudeLog } from "../../utils/amplitude";
import * as Sentry from "@sentry/react";
import { sendErrorSentryOrLocalHost } from "../../utils/funcs";

function* registerUser({ payload }: any): any {
	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	const language: any = yield select((state) => state.configs.language);
	async function apiCall() {
		try {
			const dat = {
				...payload,
				txDataHora: new Date(),
				USUARIO_FOTO: payload?.USUARIO_FOTO ?? '',
				txIdioma: language?.toLowerCase(),
			};
			
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(dat),
			};
			const res = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}acesso/acesso_cadastro`,
				requestOptions
			);
			const response: any =  res;
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao registrar usuário - registerUser',
				tags: {
					endpoint: '/acesso/acesso_cadastro',
					file: 'src/store/sagas/register.ts' 
				},
				payload: payload,
			})
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
		let message: any = "";
		if (response.status == TypesErrorRequest.FAIL) {
			if (response.code == 1) {
				message = current_language?.register_request_error_email;
			}
			if (response.code == -1) {
				message = current_language?.register_request_error;
			}
			yield put(push("/login"));
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: message,
				})
			);
		} else {
			yield put(push("/FormularyICP"));
			yield put(AppActions.set_parameter_route_icp('Welcome'))
			yield put(AppActions.set_user_id_for_icp_form(response.ID_USUARIO))

			if (response.code == 0) {
				AmplitudeLog('conta_criada', {
					usuario: {
						...payload,
						txDataHora: new Date(),
						txIdioma: language?.toLowerCase(),
					}
				});
			}
		}
	} catch (e) {
		console.log("🚀 ~ register.ts:84 ~ registerUser ~ e:", e)
		
	} finally {
		yield put(RegisterActions.register_finally());
	}
}

export function* RegisterSaga(): any {
	return yield all([takeLatest(Types.REGISTER_REQUEST, registerUser)]);
}
